const observedForms = new WeakSet();

function initializeContactForms(root) {
  root.querySelectorAll('[data-carben-contact-form]').forEach(form => {
    if (observedForms.has(form)) return;
    const feedback = form.querySelector('[data-carben-contact-feedback]');
    const message = form.querySelector('[data-carben-contact-message]');
    const assistance = form.querySelector('[data-carben-contact-assistance]');
    const button = form.querySelector('button[type="submit"]');
    const label = button?.querySelector('[data-carben-contact-submit-label]');
    if (!feedback || !message || !button || !label) return;
    observedForms.add(form);
    const initialLabel = label.textContent;
    let timeout;
    let pending = false;

    const show = (text, canRetry) => {
      feedback.hidden = false;
      message.textContent = text;
      if (assistance) assistance.hidden = !canRetry;
      button.disabled = !canRetry;
      label.textContent = canRetry ? message.dataset.contactRetryButton : message.dataset.contactPendingButton;
      button.setAttribute('aria-busy', String(!canRetry));
    };

    const recover = text => {
      clearTimeout(timeout);
      pending = false;
      show(text, true);
    };

    form.addEventListener('submit', event => {
      clearTimeout(timeout);
      if (!navigator.onLine) {
        event.preventDefault();
        event.stopImmediatePropagation();
        recover(message.dataset.contactOffline);
        return;
      }
      pending = true;
      show(message.dataset.contactPending, false);
      timeout = setTimeout(() => recover(message.dataset.contactUnconfirmed), 15000);
    }, true);

    window.addEventListener('offline', () => {
      if (pending) recover(message.dataset.contactOffline);
    });
    window.addEventListener('pagehide', () => clearTimeout(timeout));
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      clearTimeout(timeout);
      pending = false;
      button.disabled = false;
      label.textContent = initialLabel;
      feedback.hidden = true;
      button.removeAttribute('aria-busy');
    });
    form.querySelector('[data-carben-contact-response]')?.focus();
  });
}

initializeContactForms(document);
document.addEventListener('shopify:section:load', event => initializeContactForms(event.target));
